import { useCurrenciesContext, useHomeCurrencyRatesValue } from '@talos/kyoko';
import { useMemo } from 'react';

export function useHomeCurrencyConversions() {
  const currencies = useCurrenciesContext();
  const currencyStrings = useMemo(
    () => currencies.currenciesList.map(currency => currency.Symbol),
    [currencies.currenciesList]
  );

  const homeCurrencyRates = useHomeCurrencyRatesValue(currencyStrings);
  const conversionRates = useMemo(
    () => new Map(homeCurrencyRates?.map(rate => [rate.Asset, rate])),
    [homeCurrencyRates]
  );
  return conversionRates;
}
